export enum TooltipTriggerType {
  Hover = '',
  Click = 'onClick',
}
